// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedProject-module--container--12slS","header":"FeaturedProject-module--header--3USD5","generalInfo":"FeaturedProject-module--generalInfo--1NzWL"};